// ProductAlert.js
import React, { useState } from 'react';
import {
  Box,
  Flex,
  Text,
  Link,
  Button,
  Alert,
  useBreakpointValue,
} from '@chakra-ui/react';
import { FaInstagram } from 'react-icons/fa'; // Import Instagram icon

const ProductAlert = () => {
  const [showAlert, setShowAlert] = useState(true);
  const flexDir = useBreakpointValue({ base: 'column', md: 'row' });

  if (!showAlert) {
    return null; // If showAlert is false, don't render the alert
  }

  return (
    <Alert
      status="info"
      borderRadius="md"
      bg="blue.50"
      color="blue.800"
      fontWeight="bold"
      boxShadow="md"
      fontSize="sm"
    >
      <Flex align="center" direction={flexDir}>
        <Box flex="1">
          <Text>
            We are currently working hard on this product! If you have any questions or feedback, feel free to
            reach out to us.
          </Text>
        </Box>
        <Box mt={{ base: '4', md: '0' }} ml={{ base: '0', md: '4' }}>
          <Button
            size="sm"
            colorScheme="teal"
            leftIcon={<FaInstagram />}
            as={Link}
            href="https://www.instagram.com/bondchatai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Connect on Instagram
          </Button>
          <Button
            size="sm"
            ml={{ base: '0', md: '2' }}
            mt={{ base: '2', md: '0' }}
            onClick={() => setShowAlert(false)}
            variant="ghost"
            colorScheme="blue"
          >
            Close
          </Button>
        </Box>
      </Flex>
    </Alert>
  );
};

export default ProductAlert;
